<template>
  <div class="container">
    <div
      class="pageloader has-text-centered"
      v-bind:class="{ 'is-active': this.isLoadingList }"
    >
      <span class="title">{{ $t("loading.patienter") }}</span>
    </div>

    <div class="bloc" style="padding:10px;">
      <p style="font-size:16px;">
        {{ this.$store.getters.configure_links_evenement_name }}
      </p>
    </div>
    <div class="columns">
      <div class="column">
        <nav style="padding:5px;" class="card">
          <p style="margin-left:10px;font-size:14px;">
            {{ $t("link.disponible") }}
          </p>
          <div class="panel-block">
            <b-tabs type="is-toggle" expanded v-model="activeTab">
              <b-tab-item
                :visible="MeetingsDisponibles.brainstorming.length > 0"
              >
                <template slot="header">
                  <span>
                    <img
                      src="/static/logosAppli/logo-brainstorming.png"
                      class="image is-24x24"
                  /></span>
                </template>
                <div
                  :key="'Br' + MeetingDisponible.id"
                  v-for="MeetingDisponible in this.MeetingsDisponibles
                    .brainstorming"
                >
                  <b-checkbox
                    v-model="MeetingsProgrammes"
                    :native-value="{
                      name: MeetingDisponible.name,
                      tool_id: MeetingDisponible.id,
                      tool: 'brainstorming'
                    }"
                  >
                    {{ MeetingDisponible.name }}
                  </b-checkbox>
                </div>
              </b-tab-item>

              <b-tab-item :visible="MeetingsDisponibles.textit.length > 0">
                <template slot="header">
                  <span>
                    <img
                      src="/static/logosAppli/logo-textit.png"
                      class="image is-24x24"
                  /></span>
                </template>
                <div
                  :key="'Te' + MeetingDisponible.id"
                  v-for="MeetingDisponible in this.MeetingsDisponibles.textit"
                >
                  <b-checkbox
                    v-model="MeetingsProgrammes"
                    :native-value="{
                      name: MeetingDisponible.name,
                      tool_id: MeetingDisponible.id,
                      tool: 'textit'
                    }"
                  >
                    {{ MeetingDisponible.name }}
                  </b-checkbox>
                </div>
              </b-tab-item>

              <b-tab-item :visible="MeetingsDisponibles.sondage.length > 0">
                <template slot="header">
                  <span>
                    <img
                      src="/static/logosAppli/logo-sondage.png"
                      class="image is-24x24"
                  /></span>
                </template>
                <div
                  :key="'So' + MeetingDisponible.id"
                  v-for="MeetingDisponible in this.MeetingsDisponibles.sondage"
                >
                  <b-checkbox
                    v-model="MeetingsProgrammes"
                    :native-value="{
                      name: MeetingDisponible.name,
                      tool_id: MeetingDisponible.id,
                      tool: 'sondage'
                    }"
                  >
                    {{ MeetingDisponible.name }}
                  </b-checkbox>
                </div>
              </b-tab-item>

              <b-tab-item :visible="MeetingsDisponibles.quizz.length > 0">
                <template slot="header">
                  <span>
                    <img
                      src="/static/logosAppli/logo-quizz.png"
                      class="image is-24x24"
                  /></span>
                </template>
                <div
                  :key="'Qu' + MeetingDisponible.id"
                  v-for="MeetingDisponible in this.MeetingsDisponibles.quizz"
                >
                  <b-checkbox
                    v-model="MeetingsProgrammes"
                    :native-value="{
                      name: MeetingDisponible.name,
                      tool_id: MeetingDisponible.id,
                      tool: 'quizz'
                    }"
                  >
                    {{ MeetingDisponible.name }}
                  </b-checkbox>
                </div>
              </b-tab-item>

              <b-tab-item :visible="MeetingsDisponibles.profeel.length > 0">
                <template slot="header">
                  <span>
                    <img
                      src="/static/logosAppli/logo-profeel.png"
                      class="image is-24x24"
                  /></span>
                </template>
                <div
                  :key="'Pf' + MeetingDisponible.id"
                  v-for="MeetingDisponible in this.MeetingsDisponibles.profeel"
                >
                  <b-checkbox
                    v-model="MeetingsProgrammes"
                    :native-value="{
                      name: MeetingDisponible.name,
                      tool_id: MeetingDisponible.id,
                      tool: 'profeel'
                    }"
                  >
                    {{ MeetingDisponible.name }}
                  </b-checkbox>
                </div>
              </b-tab-item>

              <b-tab-item>
                <template slot="header">
                  <span>
                    <img
                      src="/static/logosAppli/logo-custom.png"
                      class="image is-24x24"
                  /></span>
                </template>
                {{ $t("link.creer_custom") }}
                <b-field>
                  <b-input
                    value=""
                    v-model="custom_name"
                    expanded
                    required
                    placeholder="Nom du lien"
                  ></b-input>
                </b-field>
                <b-field>
                  <b-input
                    type="url"
                    required
                    value=""
                    v-model="custom_url"
                    expanded
                    placeholder="URL du lien"
                  ></b-input>
                </b-field>
                <b-field>
                  <button class="button is-success" @click="valideCustom">
                    {{ $t("button.sauvegarder_custom") }}
                  </button>
                </b-field>
              </b-tab-item>
            </b-tabs>
          </div>
        </nav>
      </div>

      <div class="column">
        <nav style="padding:5px;" class="card">
          <p style="margin-left:10px;font-size:14px;">
            {{ $t("link.deroule") }}
          </p>
          <div class="panel-block">
            <draggable :list="this.MeetingsProgrammes" class="dragArea">
              <transition-group name="list-complete">
                <div
                  v-for="(MeetingProgramme, index) in this.MeetingsProgrammes"
                  :key="MeetingProgramme.tool_id + MeetingProgramme.tool"
                  class="list-complete-item"
                >
                  <img
                    class="image is-24x24 is-pulled-left"
                    :src="
                      '/static/logosAppli/logo-' +
                        MeetingProgramme.tool +
                        '.png'
                    "
                  />
                  <a
                    :href="MeetingProgramme.tool_id"
                    target="_blank"
                    v-if="MeetingProgramme.tool == 'custom'"
                  >
                    <span class="meetingname">{{ MeetingProgramme.name }}</span>
                  </a>
                  <span
                    class="meetingname"
                    v-if="MeetingProgramme.tool !== 'custom'"
                    >{{ MeetingProgramme.name }}</span
                  >
                  <a @click="remove(index)" class="delete is-pulled-right"></a>
                </div>
              </transition-group>
            </draggable>
          </div>
          <br />
          <a
            style="margin-left:10px;"
            class="button validate"
            @click="saveDeroule"
            :class="{ 'is-loading': this.sending }"
            >{{ $t("button.sauvegarder") }}</a
          >
        </nav>
      </div>
    </div>
    <br /><br /><br />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import axios from "axios";

export default {
  name: "lienList",
  data() {
    return {
      isLoadingList: true,
      sending: false,
      activeTab: 0,
      list: [],
      url_sso_front: process.env.URL_SSO_FRONT,
      custom_name: "",
      custom_url: "",
      MeetingsProgrammes: [],
      MeetingsDisponibles: {
        brainstorming: [],
        textit: [],
        sondage: [],
        profeel: [],
        quizz: []
      }
    };
  },
  components: {
    draggable
  },
  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + window.store.getters.userToken;
    // Récupération des meetings programmes
    axios
      .get(
        process.env.URL_SSO_API +
          "shortcut/event/" +
          window.store.getters.configure_links_evenement +
          "/link"
      )
      .then(response => {
        this.isLoadingList = false;
        // [name,tool_id,tool]
        for (var element in response.data) {
          this.MeetingsProgrammes.push({
            name: response.data[element].name,
            tool_id: response.data[element].tool_id,
            tool: response.data[element].tool
          });
        }
      })
      .catch(error => {
        // window.location = process.env.URL_SSO_FRONT
      });

    // Récupération des Brainstorming programmes
    axios
      .get(process.env.URL_SSO_API + "brainstorming/board/boards")
      .then(response => {
        this.MeetingsDisponibles.brainstorming = response.data;
      })
      .catch(error => {
        // window.location = process.env.URL_SSO_FRONT
      });

    // Récupération des textit programmes
    axios
      .get(process.env.URL_SSO_API + "textit/meeting/colidee/null/null")
      .then(response => {
        this.MeetingsDisponibles.textit = response.data;
      })
      .catch(error => {
        // window.location = process.env.URL_SSO_FRONT
      });

    // Récupération des sondages programmes
    axios
      .get(process.env.URL_SSO_API + "sondage/sondage/colidee/null/null")
      .then(response => {
        this.MeetingsDisponibles.sondage = response.data;
      })
      .catch(error => {
        // window.location = process.env.URL_SSO_FRONT
      });

    // Récupération des quizz programmes
    axios
      .get(process.env.URL_SSO_API + "quizz/quizzs")
      .then(response => {
        this.MeetingsDisponibles.quizz = response.data;
      })
      .catch(error => {
        // window.location = process.env.URL_SSO_FRONT
      });
    // Récupération des profeel programmes
    axios
      .get(process.env.URL_SSO_API + "insight/insight")
      .then(response => {
        this.MeetingsDisponibles.profeel = response.data;
      })
      .catch(error => {
        // window.location = process.env.URL_SSO_FRONT
      });
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    valideCustom() {
      if (
        (this.custom_url.indexOf("http://") != "-1" ||
          this.custom_url.indexOf("https://") != "-1") &&
        this.custom_name != ""
      ) {
        this.MeetingsProgrammes.push({
          name: this.custom_name,
          tool_id: this.custom_url,
          tool: "custom"
        });
        this.custom_name = "";
        this.custom_url = "";
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          position: "is-top",
          message: this.$i18n.t("toast.CustomNOK")
        });
      }
    },
    remove: function(index) {
      this.MeetingsProgrammes.splice(index, 1);
    },
    saveDeroule: function() {
      this.sending = true;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + window.store.getters.userToken;
      axios
        .post(
          process.env.URL_SSO_API +
            "shortcut/event/" +
            window.store.getters.configure_links_evenement +
            "/savelink",
          this.MeetingsProgrammes
        )
        .then(response => {
          this.sending = false;
          this.$buefy.toast.open({
            type: "is-success",
            position: "is-top",
            message: this.$i18n.t("toast.enregistrementOK")
          });
        })
        .catch(err => {
          console.log('An error is occured');
        });
    }
  }
};
</script>

<style scoped type="text/css">
.validate {
  background: #424a60;
  color: white;
}

.meetingname {
  margin-left: 10px;
}
.dragArea {
  width: 100%;
}

.list-complete-item:hover {
  cursor: pointer;
  background: #f5f5f5;
}

.list-complete-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
  transition: all 0.5s;
}

.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/link/LinkList.vue